import { render } from "./ConfirmCustomerSegmentModal.vue?vue&type=template&id=622b24fe&scoped=true"
import script from "./ConfirmCustomerSegmentModal.vue?vue&type=script&lang=js"
export * from "./ConfirmCustomerSegmentModal.vue?vue&type=script&lang=js"

import "./ConfirmCustomerSegmentModal.vue?vue&type=style&index=0&id=622b24fe&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622b24fe"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QCard,QCardSection});
